import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { isEmpty } from "lodash";
export default {
  init($) {
    $.fn.globalDeletion = function (title = "Confirm Deletion", bodyContent = "", acceptContent = null, dismissContent = null) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const target = this;
      const isPopover = !isEmpty(this.data("bs.popover"));
      if (!isPopover) {
        const content = `
      <div class="deletion-container d-flex align-items-center">
       <span class="confirmation-text pr-2 text-gray">${bodyContent}</span>
       <a
        class="prompt-link accept-link clickable mr-1"
      >
        ${acceptContent ? "<span>" + acceptContent + "</span>" : '<i class="fa fa-check"></i>'}

      </a>
       <a
        class="prompt-link dismiss-link clickable"
      >
        ${dismissContent ? "<span>" + dismissContent + "</span>" : '<i class="fa fa-times mx-1 clickable text-gray"></i>'}
      </a>

    </div>
      `;
        target.popover({
          animation: true,
          container: "body",
          html: true,
          content: `${content}`,
          boundary: "viewport",
          placement: "top",
          trigger: "focus",
          title: `${title}`
        }).attr("data-toggle", "popover").one("hidden.bs.popover", () => {
          $(`#${id}`).remove();
        }).popover("show");
      }
      const id = target.attr("aria-describedby");
      return new _Promise(resolve => {
        const resolvePromise = status => {
          resolve(status);
          target.removeAttr("data-toggle").popover("hide");
        };
        target.one("shown.bs.popover", () => {
          $(`#${id} a.accept-link`).one("click", () => resolvePromise(true));
          $(`#${id} a.dismiss-link`).one("click", () => resolvePromise(false));
        });
      });
    };
  }
};